import React from 'react';

/**
 * LUXROBO 브랜드 마크 (placeholder).
 *
 * 운영팀이 실제 brand SVG / PNG 를 받으면 이 파일만 교체하면 다른 화면은 그대로
 * 동작한다. props 는 size 만 받고 색은 currentColor 로 상속받게 해서 dark / light
 * 두 panel 에서 같은 컴포넌트를 그대로 쓸 수 있다.
 *
 * 임시 디자인: 직각 격자 + 원형 노드 — robotics + smart-parking 의 grid sensing
 * 메타포. 단순해서 favicon 32px 까지 견딘다.
 */
interface LuxroboMarkProps {
  size?: number;
  title?: string;
}

const LuxroboMark: React.FC<LuxroboMarkProps> = ({ size = 36, title = 'LUXROBO' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    role="img"
    aria-label={title}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    {/* 외곽 사각 */}
    <rect
      x="3"
      y="3"
      width="34"
      height="34"
      rx="8"
      stroke="currentColor"
      strokeWidth="2"
    />
    {/* 격자 — 옅게 */}
    <path
      d="M14 6V34M26 6V34M6 14H34M6 26H34"
      stroke="currentColor"
      strokeOpacity="0.32"
      strokeWidth="1"
    />
    {/* 중앙 노드 — accent */}
    <circle cx="20" cy="20" r="3.2" fill="currentColor" />
  </svg>
);

export default LuxroboMark;
